export enum ZStratum {
    BASE = 0,
    TIP = 10,
    DROPDOWN = 100,
    BAR = 1000,
    DIALOG = 10000,
}
